import * as React from "react";

import { cn } from "@/lib/utils.js";

function Input({ className, type, ...props }: React.ComponentProps<"input">) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        "file:text-foreground placeholder:text-muted-foreground/70 dark:placeholder:text-muted-foreground/60 selection:bg-primary selection:text-primary-foreground dark:bg-input/50 border-input flex h-10 w-full min-w-0 rounded-md border bg-background/50 dark:bg-background/80 px-3 py-2 text-base shadow-sm transition-[color,box-shadow,border-color] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        "focus-visible:border-ring focus-visible:ring-ring/30 focus-visible:ring-2 focus-visible:bg-background dark:focus-visible:bg-background/90",
        "hover:border-input/80 dark:hover:border-input/60",
        "aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
        className,
      )}
      {...props}
    />
  );
}

export { Input };
